export default function FaqItem({ question, answer, isOpen, onToggle }) {
  return (
    <div
      className={`rounded-2xl border ${
        isOpen
          ? "bg-[#f3f0fb] border-[#f3f0fb]"
          : "bg-white border-gray-200"
      }`}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between text-left px-5 py-4 focus:outline-none no-scale"
      >
        <span className="font-semibold text-gray-900 text-[15px] md:text-base pr-4">
          {question}
        </span>
        <span
          className={`shrink-0 flex items-center justify-center w-7 h-7 rounded-full text-xl leading-none ${
            isOpen ? "bg-[#7828C8] text-white" : "text-black font-medium"
          }`}
        >
          {isOpen ? "-" : "+"}
        </span>
      </button>

      {isOpen && answer && (
        <div className="px-5 pb-5 -mt-1 text-gray-700 text-[15px] leading-relaxed">
          {answer}
        </div>
      )}
    </div>
  );
}
